<template>
  <v-container fluid>
    <PageTitle title="Users" />

    <ApiDataTable
      data-api="users"
      :can-insert="true"
      :can-update="true"
      :can-delete="true"
      :can-filter="true"
      :show-paging="true"
      :toolbar-buttons="[{title:'Import',icon:'mdi-import'}]"
      @toolbar-button-click="importUsers"
      :row-buttons="[{title:'Roles',icon:'mdi-shield-edit-outline'}]"
      @row-button-click="editUser"
    />

    <v-dialog v-model="dialog" scrollable width="800">
      <v-card>
        <v-card-title>Edit {{ user.name }} roles</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <ApiDataTable
            ref="user_roles"
            data-api="rolemembers"
            :can-insert="true"
            :can-delete="true"
            :filters="filters"
            :params="params"
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialog=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="importDialog" scrollable width="800" persistent>
      <v-card :disabled="importing" :loading="importing">
        <v-card-title>Import</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-alert color="info">File format for each line = username,email,password,providerName(or local) and no column header!</v-alert>
          <v-form v-model="importForm">
            <v-file-input filled :rules="importFileRule" v-model="importFileValue" placeholder="Pick an txt or csv file."></v-file-input>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" :disabled="!importForm" @click="doImportUsers">Import</v-btn>
          <v-btn text color="error" @click="importDialog=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ApiDataTable from "../ui/shared/ApiDataTable.vue";
import server from "../../services/server";
import PageTitle from "../ui/shared/PageTitle.vue";

export default {
  name: "Users",
  
  components: { ApiDataTable, PageTitle },

  data() {
    return {
      dialog: false,
      importDialog: false,
      importFileRule: [
        (file) =>
          (file && file.size < 10000000) ||
          "File size should be less than 10000000 MB!",
      ],
      importForm: true,
      importing: false,
      user: {},
      filters: [
        {
          name: "userId",
          compare: "=",
          value: null,
        },
      ],
      params: {
        userId: null,
      },
      importFileValue: null,
    };
  },

  methods: {
    editUser({ item }) {
      this.user = item;
      this.filters[0].value = item.id;
      this.params.userId = item.id;
      this.dialog = true;

      if (this.$refs.user_roles) this.$refs.user_roles.refresh(true);
    },
    importUsers() {
      this.importDialog = true;
    },
    doImportUsers() {
      this.importing = true;

      var fd = new FormData();
      fd.append("file", this.importFileValue);

      server
        .upload("users/import", fd)
        .then(() => {
          this.importing = false;
          this.importDialog = false;
        })
        .catch((e) => {
          alert(e.toString());
          this.importing = false;
        });
    },
  },
};
</script>
